import React from "react";
import { ProjectDetailsSc } from "./index.sc";

function Index(props: any) {
  return (
    <>
      <ProjectDetailsSc>
        <div className="card-container">
          <div className="project-name"> {props.ProjectName}</div>
          <div>Description : {props?.description}</div>
        </div>
      </ProjectDetailsSc>
    </>
  );
}

export default Index;
